import * as React from "react";
import { withFetch } from "./common/fetch";

function PhoneErrorsLogger(Component) {
  class PhoneErrorsLoggerHOC extends React.Component {
    query = data => {
      const {
        filtered_input,
        user_input,
        error_msg,
        source,
        phone_example
      } = data;

      const params = [];

      filtered_input &&
        params.push(`filtered_input=${encodeURIComponent(filtered_input)}`);
      user_input && params.push(`user_input=${encodeURIComponent(user_input)}`);
      error_msg &&
        params.push(
          `error_msg=${encodeURIComponent(
            process.env.REACT_APP_DEPLOY_TARGET === "irontrade" ? "Iron " : "Siam " + error_msg
          )}`
        );
      source && params.push(`source=${encodeURIComponent(source)}`);
      phone_example &&
        params.push(`phone_example=${encodeURIComponent(phone_example)}`);

      if (!params.length) return null;

      return this.props.fetch(
        `/api/stat/track-phone-error?${params.join("&")}`,
        {
          unstable_dontInferResponse: true
        }
      );
    };

    render() {
      return <Component {...this.props} logPhoneErrors={this.query} />;
    }
  }

  return withFetch(PhoneErrorsLoggerHOC);
}

export default PhoneErrorsLogger;



// WEBPACK FOOTER //
// ./src/components/PhoneErrorsLogger.js